import { render, staticRenderFns } from "./GdprPopup.vue?vue&type=template&id=5a4da792&scoped=true"
import script from "./GdprPopup.vue?vue&type=script&lang=js"
export * from "./GdprPopup.vue?vue&type=script&lang=js"
import style0 from "./GdprPopup.vue?vue&type=style&index=0&id=5a4da792&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4da792",
  null
  
)

export default component.exports